import React from 'react'

const CartDone = () => {
    return (
        <>
            <svg
                width={60}
                height={60}
                viewBox="0 0 512 512"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clipPath="url(#clip0_597_472)">
                    <path d="M304 32H480V128H304V32Z" fill="#00DDC2" />
                    <path d="M304 64H480V128H304V64Z" fill="#0AC1A7" />
                    <path d="M176 0H336V128H176V0Z" fill="#FF668B" />
                    <path d="M176 64H336V128H176V64Z" fill="#F7487A" />
                    <path
                        d="M272 456C272 486.93 246.93 512 216 512C185.07 512 160 486.93 160 456C160 425.07 185.07 400 216 400C246.93 400 272 425.07 272 456ZM464 456C464 486.93 438.93 512 408 512C377.07 512 352 486.93 352 456C352 425.07 377.07 400 408 400C438.93 400 464 425.07 464 456Z"
                        fill="#57565C"
                    />
                    <path
                        d="M496 368H131.664L51.664 64H16C7.168 64 0 56.832 0 48C0 39.168 7.168 32 16 32H76.336L156.336 336H496C504.832 336 512 343.168 512 352C512 360.832 504.832 368 496 368Z"
                        fill="#77959E"
                    />
                    <path
                        d="M448 304H180.945L126.29 96H512V240C512 275.344 483.344 304 448 304Z"
                        fill="#FDD835"
                    />
                    <path
                        d="M464 256C455.168 256 448 248.832 448 240V144C448 135.168 455.168 128 464 128C472.832 128 480 135.168 480 144V240C480 248.832 472.832 256 464 256ZM304 256C295.168 256 288 248.832 288 240V144C288 135.168 295.168 128 304 128C312.832 128 320 135.168 320 144V240C320 248.832 312.832 256 304 256ZM384 256C375.168 256 368 248.832 368 240V144C368 135.168 375.168 128 384 128C392.832 128 400 135.168 400 144V240C400 248.832 392.832 256 384 256ZM224 256C215.168 256 208 248.832 208 240V144C208 135.168 215.168 128 224 128C232.832 128 240 135.168 240 144V240C240 248.832 232.832 256 224 256Z"
                        fill="#FBC02D"
                    />
                    <path
                        d="M216 480C190.719 480 169.55 463.055 162.61 440C161.07 445.105 160 450.398 160 456C160 486.879 185.121 512 216 512C246.879 512 272 486.879 272 456C272 450.398 270.93 445.105 269.39 440C262.45 463.055 241.281 480 216 480ZM408 480C382.719 480 361.55 463.055 354.61 440C353.07 445.105 352 450.398 352 456C352 486.879 377.121 512 408 512C438.879 512 464 486.879 464 456C464 450.398 462.93 445.105 461.39 440C454.45 463.055 433.281 480 408 480Z"
                        fill="#2D2D30"
                    />
                    <path
                        d="M448 272H172.543L180.961 304H448C483.344 304 512 275.344 512 240V208C512 243.344 483.344 272 448 272Z"
                        fill="#FBC02D"
                    />
                    <path
                        d="M117.333 399.666C182.134 399.666 234.666 347.134 234.666 282.333C234.666 217.532 182.134 165 117.333 165C52.5318 165 0 217.532 0 282.333C0 347.134 52.5318 399.666 117.333 399.666Z"
                        fill="#4CAF50"
                    />
                    <path
                        d="M95.9991 335.667C94.5974 335.67 93.2088 335.396 91.913 334.861C90.6171 334.327 89.4394 333.542 88.4471 332.552L45.7801 289.885C41.6881 285.648 41.8051 278.895 46.0421 274.802C50.1761 270.81 56.7291 270.81 60.8621 274.802L95.9981 309.917L173.779 232.136C177.872 227.899 184.624 227.782 188.862 231.874C193.1 235.966 193.216 242.719 189.124 246.957C189.038 247.046 188.951 247.133 188.862 247.219L103.529 332.552C101.53 334.546 98.8225 335.666 95.9991 335.667Z"
                        fill="#FAFAFA"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_597_472">
                        <rect width={512} height={512} fill="white" />
                    </clipPath>
                </defs>
            </svg>

        </>
    )
}

export default CartDone